import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import styles from './Checkbox.module.scss'

const StyledCheckbox = ({ boxStyles, compareTodayStyled, compareWithStyled, smartSubmit, inline, styleInverted, noForm, label, stopPropagation, indeterminate, checkOnLabelClick, ...rest }) => {
	const stopClickPropagation = e => {
		if (stopPropagation) {
			e.stopPropagation()
		}
	}

	let checkbox = (
		<Fragment>
			<input type='checkbox' {...rest} />
			<span
				className={classNames(styles.box)}
				style={boxStyles}
			/>
		</Fragment>
	)
	checkbox = checkOnLabelClick ?
		(<label className={styles.label} onClick={stopClickPropagation}>
			{checkbox}
			<span className={styles.labelText}>{label}</span>
		</label>) :
		(<div className={styles.label}>
			<label onClick={stopClickPropagation}>{checkbox}</label>
			{label}
		</div>)


	return (
		<div
			className={
				classNames(
					styles.root,
					rest.className,
					{
						compare_today__active: compareTodayStyled,
						compare_with__active: compareWithStyled,
						inline: inline,
						[styles.inverted]: styleInverted,
						[`${'field-disabled'}`]: rest.disabled,
						[styles.indeterminate]: indeterminate && !rest.checked
					})
			}
		>
			{checkbox}
		</div>
	)
}

StyledCheckbox.propTypes = {
	field: PropTypes.string,
	label: PropTypes.string,
	inline: PropTypes.bool,
	styleInverted: PropTypes.bool,
	indeterminate: PropTypes.bool,
	noForm: PropTypes.bool,
	stopPropagation: PropTypes.bool,
	checkOnLabelClick: PropTypes.bool
}

StyledCheckbox.defaultProps = {
	checkOnLabelClick: true
}

export default StyledCheckbox
